// Sync discount code từ product page → Cart Drawer
(function () {
  const STORAGE_KEY = 'duts_discount_code';

  // Lắng nghe khi user nhập code trên product page
  document.addEventListener('input', function (e) {
    const input = e.target;
    if (
      input.type === 'text' &&
      (input.name === 'discount' ||
        input.id?.includes('discount') ||
        input.className?.includes('discount'))
    ) {
      localStorage.setItem(STORAGE_KEY, input.value.trim());
    }
  });

  // Khi Cart Drawer mở → tự điền code
  function fillDrawerCode() {
    const savedCode = localStorage.getItem(STORAGE_KEY);
    if (!savedCode) return;

    const drawerInputs = document.querySelectorAll(
      'cart-drawer input[type="text"], #CartDrawer input[type="text"], .cart-drawer input[type="text"]'
    );
    drawerInputs.forEach(function (input) {
      if (
        input.name === 'discount' ||
        input.id?.includes('discount') ||
        input.className?.includes('discount')
      ) {
        if (!input.value) input.value = savedCode;
      }
    });
  }

  // Observer theo dõi Cart Drawer khi mở
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) {
          fillDrawerCode();
        }
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });

  // Cũng chạy khi page load (nếu drawer đã render sẵn)
  document.addEventListener('DOMContentLoaded', fillDrawerCode);
})();
